const styles = {
  iconStyle: {
    //navbar page
    width: "20px",
    height: "20px",
    cursor: "pointer",
    color: "var(--text-primary)",
  },
  circularProgressStyle: {
    width: "15px",
    height: "15px",
    color: "white",
  },
  avatarStyle: {
    bgcolor: "#8774e1",
    cursor: "pointer",
    fontWeight: "bold",
    width: "35px",
    height: "35px",
    fontFamily: "poppines",
  },
  cameraIconStyle: {
    //profile page
    width: "25px",
    height: "25px",
    cursor: "pointer",
    color: "var(--text-primary)",
    border: "1.5px solid var(--text-primary)",
    borderRadius: "50%",
  },
  avatar40x40: {
    //home page
    bgcolor: "#8774e1",
    cursor: "pointer",
    fontWeight: "bold",
    width: "40px",
    height: "40px",
    fontFamily: "poppines",
  },
};

export default styles;
